import React from "react";
import { Helmet } from "react-helmet";

const About = () => {
  return (
    <>
      <Helmet>
        <meta charset="utf-8" />
        <meta
          name="description"
          content="Our firm offers comprehensive services in corporate law, regulatory compliance, risk management, and dispute resolution, providing practical, proactive, and innovative solutions"
        />
        <title>About LegalNest</title>
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta
          name="keywords"
          content="
  legal compliance services,
  regulatory compliance consultants,
  corporate law firm,
  legal advisory services,
  insurance compliance solutions,
  legal risk management,
  dispute resolution experts,
  corporate legal services,
  compliance and legal advisory,
  legal consulting firm,
  legal and insurance compliance,
  regulatory risk management,
  business law solutions,
  legal compliance specialists,
  corporate governance consultants,
  proactive legal support,
  legal compliance for businesses,
  Legal Nest legal services,
  Legal Nest compliance advisors,
  agile legal firm in India,
  modern legal compliance firm,
  expert regulatory compliance team,
  Legal Nest corporate law solutions
"
        />

        <meta name="author" content="Mantra Jha" />
      </Helmet>
      <div id="content" className="site-content">
        <div
          className="page-title-wrap text-left parallax"
          style={{ padding: "", backgroundAttachment: "fixed" }}
        >
          <div className="container">
            <h1 className="page-title display_none" style={{ color: "" }}>
              <span>About Us</span>
            </h1>
          </div>
        </div>
        <div className="container ct-lv1">
          <div className="row">
            <div
              id="primary"
              className="content-area content-page col-xs-12 col-sm-12 col-md-12 col-lg-12"
            >
              <main id="main" className="site-main" role="main">
                <div
                  id="post-6"
                  className="post-6 page type-page status-publish hentry"
                >
                  <div className="entry-content">
                    <div className="wpb-content-wrapper">
                      <div
                        data-vc-full-width="true"
                        data-vc-full-width-init="false"
                        className="vc_row wpb_row vc_row-fluid vc_custom_1448505249214 vc_row-has-fill"
                      >
                        <div className="wpb_column vc_column_container vc_col-sm-3">
                          <div className="vc_column-inner">
                            <div className="wpb_wrapper">
                              <div
                                className="st-custom-heading-wraper st-custom-heading-layout2 text-default"
                                style={{ marginBottom: "" }}
                              >
                                <h2
                                  className="st-heading-title"
                                  style={{ color: "" }}
                                >
                                  <span> About Us</span>
                                </h2>
                                <hr
                                  className="heading-line"
                                  style={{ background: "" }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="wpb_column vc_column_container vc_col-sm-9">
                          <div className="vc_column-inner">
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element vc_custom_1451638423947">
                                <div className="wpb_wrapper">
                                  <p>
                                    At Legal Nest, we think differently. We’re a
                                    team where fresh talent meets real-world
                                    experience, creating a space that’s agile,
                                    ambitious, and ready to grow with you. From
                                    regulatory compliance to legal advisory, we
                                    approach every challenge with energy,
                                    precision, and a go-getter mindset. Driven
                                    by passion, guided by expertise - we’re
                                    building the future of legal and insurance
                                    compliance, one smart solution at a time.
                                    Our commitment to staying sharp, dedicated,
                                    and dynamic ensures that we don’t just keep
                                    up - we stay ahead.
                                  </p>

                                  <p>
                                    Our firm offers comprehensive services in
                                    corporate law, regulatory compliance, risk
                                    management, and dispute resolution,
                                    providing practical, proactive, and
                                    innovative solutions.{" "}
                                  </p>

                                  <p>
                                    We believe in fostering strong client
                                    relationships built on trust, transparency,
                                    and collaboration.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="vc_row-full-width vc_clearfix" />
                      <div className="vc_row wpb_row vc_row-fluid vc_custom_1451643904594">
                        <div className="wpb_column vc_column_container vc_col-sm-6">
                          <div className="vc_column-inner">
                            <div className="wpb_wrapper">
                              <div className="wpb_single_image wpb_content_element vc_align_left wpb_content_element vc_custom_1448509474965">
                                <figure className="wpb_wrapper vc_figure">
                                  <div className="vc_single_image-wrapper vc_box_border_grey">
                                    <img
                                      fetchpriority="high"
                                      decoding="async"
                                      width={556}
                                      height={418}
                                      src="https://images.unsplash.com/photo-1521587760476-6c12a4b040da?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                                      className="vc_single_image-img attachment-full"
                                      alt=""
                                      title="about1"
                                    />
                                  </div>
                                </figure>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="wpb_column vc_column_container vc_col-sm-6">
                          <div className="vc_column-inner">
                            <div className="wpb_wrapper">
                              <div
                                className="st-custom-heading-wraper st-custom-heading-layout2 text-default"
                                style={{ marginBottom: "" }}
                              >
                                <h2
                                  className="st-heading-title"
                                  style={{ color: "" }}
                                >
                                  <span>What Sets Us Apart</span>
                                </h2>
                                <hr
                                  className="heading-line"
                                  style={{ background: "" }}
                                />
                              </div>
                              <div className="vc_row wpb_row vc_inner vc_row-fluid vc_custom_1448509361293">
                                <div className="wpb_column vc_column_container vc_col-sm-12">
                                  <div className="vc_column-inner">
                                    <div className="wpb_wrapper">
                                      <div className="st-feature-box-wraper st-feature-box-layout1 text-default">
                                        <div className="st-feature-box">
                                          <div className="st-feature-box-icon">
                                            <div className="feature-box-image">
                                              <img
                                                decoding="async"
                                                src="../wp-content/uploads/2015/11/icon3.png"
                                                alt=""
                                              />
                                            </div>
                                          </div>
                                          <h3>24 Hour Online support</h3>
                                          <div className="feature-box-content">
                                            Round-the-Clock Expert Assistance
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <br />

                              <div className="vc_row wpb_row vc_inner vc_row-fluid vc_custom_1448509352887">
                                <div className="wpb_column vc_column_container vc_col-sm-12">
                                  <div className="vc_column-inner">
                                    <div className="wpb_wrapper">
                                      <div className="st-feature-box-wraper st-feature-box-layout1 text-default">
                                        <div className="st-feature-box">
                                          <div className="st-feature-box-icon">
                                            <div className="feature-box-image">
                                              <img
                                                decoding="async"
                                                src="../wp-content/uploads/2015/11/icon5.png"
                                                alt=""
                                              />
                                            </div>
                                          </div>
                                          <h3>Dedicated Team</h3>
                                          <div className="feature-box-content">
                                            Your Trusted Partner in Professional
                                            Services
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <br />
                              <div className="vc_row wpb_row vc_inner vc_row-fluid vc_custom_1448509369126">
                                <div className="wpb_column vc_column_container vc_col-sm-12">
                                  <div className="vc_column-inner">
                                    <div className="wpb_wrapper">
                                      <div className="st-feature-box-wraper st-feature-box-layout1 text-default">
                                        <div className="st-feature-box">
                                          <div className="st-feature-box-icon">
                                            <div className="feature-box-image">
                                              <img
                                                decoding="async"
                                                src="../wp-content/uploads/2015/11/icon1.png"
                                                alt=""
                                              />
                                            </div>
                                          </div>
                                          <h3>Business Consulting</h3>
                                          <div className="feature-box-content">
                                            Strategic Solutions for Business
                                            Success
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <br />
                              <div className="vc_row wpb_row vc_inner vc_row-fluid">
                                <div className="wpb_column vc_column_container vc_col-sm-12">
                                  <div className="vc_column-inner">
                                    <div className="wpb_wrapper">
                                      <div className="st-feature-box-wraper st-feature-box-layout1 text-default">
                                        <div className="st-feature-box">
                                          <div className="st-feature-box-icon">
                                            <div className="feature-box-image">
                                              <img
                                                decoding="async"
                                                src="../wp-content/uploads/2015/11/icon2.png"
                                                alt=""
                                              />
                                            </div>
                                          </div>
                                          <h3>Lawyer Consulting</h3>
                                          <div className="feature-box-content">
                                            Legal Expertise You Can Rely On
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <br />
                            </div>
                          </div>
                        </div>
                      </div>

                      <br />
                      <br />
                      <br />
                      <br />

                      <div className="vc_row-full-width vc_clearfix" />

                      <div
                        data-vc-full-width="true"
                        data-vc-full-width-init="false"
                        data-vc-parallax="1.5"
                        className="vc_row wpb_row vc_row-fluid opacity06 vc_custom_1451644812563 vc_row-has-fill vc_general vc_parallax vc_parallax-content-moving"
                      >
                        <div className="wpb_column vc_column_container vc_col-sm-12">
                          <div className="vc_column-inner">
                            <div className="wpb_wrapper">
                              <div className="call-to-action call-to-action-layout1">
                                <div className="row">
                                  <div className="col-xs-12 col-sm-8 col-md-8 col-lg-8 call-to-action-text text-default">
                                    <h2
                                      className="cta-heading"
                                      style={{ color: "#ffffff" }}
                                    >
                                      CONSULTING SERVICE
                                    </h2>
                                    <div
                                      className="cta-subheading"
                                      style={{ color: "#e2e2e2" }}
                                    >
                                      We provide wide range of Consulting
                                      Services
                                    </div>
                                  </div>
                                  <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 call-to-action-button text-default">
                                    <a
                                      href="/Contact"
                                      className="btn btn-regular btn-custom"
                                      style={{
                                        backgroundColor: "#fe5722",
                                        color: "#ffffff",
                                      }}
                                    >
                                      START YOUR PROJECT NOW
                                      <i className="fa fa-angle-right" />
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="vc_row-full-width vc_clearfix" />
                    </div>
                  </div>
                  {/* .entry-content */}
                  <div className="page-edit" />
                  {/* .entry-footer */}
                </div>
                {/* #post-## */}
              </main>
              {/* #main */}
            </div>

            {/* #primary */}
          </div>
          {/* #row */}
        </div>
        {/* #container */}
      </div>
    </>
  );
};

export default About;
